import { useEffect, useState } from 'react';

import { groupBy } from 'lodash';
import { useSnapshot } from 'valtio';

import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import {
  clearAssetSelection,
  setRefrigerationUnitModels,
  store,
  toggleManufacturer,
  toggleRefrigerationUnitModel,
} from '@/components/pages/EmissionsDashboard/store';

import { useGetRefrigerationUnitModelsQuery } from '@/graphql/GetRefrigerationUnitModels.generated';

import { reportRequestError, retryAfterRequestError } from '@/store';

function RefrigerationUnitModelsFilterList() {
  const snap = useSnapshot(store);

  const [{ data, fetching, error }, reexecuteQuery] =
    useGetRefrigerationUnitModelsQuery({
      pause: snap.refrigerationUnitModels.length > 0,
    });

  const [errorId, setErrorId] = useState<string | null>(null);

  useEffect(() => {
    if (data && data.container_insights_refrigeration_unit_models) {
      setRefrigerationUnitModels(
        data.container_insights_refrigeration_unit_models,
      );
    }
  }, [data]);

  useEffect(() => {
    if (error) {
      setErrorId(reportRequestError(error, reexecuteQuery));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  const handleRetry = () => {
    retryAfterRequestError(errorId);
    setErrorId(null);
  };

  const handleToggleManufacturer = (name: string) => () => {
    toggleManufacturer(name);
    clearAssetSelection();
  };

  const handleToggleModel = (id: string) => () => {
    toggleRefrigerationUnitModel(id);
    clearAssetSelection();
  };

  const groups = groupBy(snap.refrigerationUnitModels, 'manufacturer.name');

  return (
    // {!fetching && appSnap.hasRequestError(errorId) && (
    //   <FormHelperText
    //     sx={(theme) => ({
    //       color: theme.palette.error.main,
    //       display: 'flex',
    //       alignItems: 'center',
    //       gap: 0.5,
    //       marginLeft: 2,
    //     })}
    //   >
    //     <ErrorOutlineIcon fontSize="small" />
    //     Error while fetching models
    //   </FormHelperText>
    // )}
    <List sx={{ pt: 0, height: 440, maxHeight: 440, overflow: 'scroll' }} dense>
      {Object.entries(groups).map(([manufacturerName, models]) => (
        <Box key={manufacturerName}>
          <ListItemButton
            sx={{ p: 0, pl: 0.5 }}
            onClick={handleToggleManufacturer(manufacturerName)}
          >
            <ListItemIcon>
              <Checkbox
                disableRipple
                checked={models.some((model) => model.selected)}
              />
            </ListItemIcon>
            <ListItemText primary={models[0].manufacturer.label} />
          </ListItemButton>
          {models.map((model) => (
            <List key={model.name} sx={{ pl: 4 }} disablePadding dense>
              <ListItemButton
                sx={{ p: 0 }}
                onClick={handleToggleModel(model.id)}
              >
                <ListItemIcon>
                  <Checkbox disableRipple checked={model.selected} />
                </ListItemIcon>
                <ListItemText primary={model.name} />
              </ListItemButton>
            </List>
          ))}
          <Divider sx={{ width: '100%' }} />
        </Box>
      ))}
    </List>
  );
}

export { RefrigerationUnitModelsFilterList };
